export const _LOAD_MODEL_COMPANY_ = 'Load:Company';
export const _LOAD_MODEL_MESSAGE_ = 'Load:Message';
export const _LOAD_MODEL_SETTING_ = 'Load:Setting';
export const _LOAD_DRIVE_GOAL_ = 'Load:SettingDriveGoal';
export const _SAVE_DRIVE_GOAL_ = 'Save:SettingDriveGoal';

export const PRICES = {
  mm: 0,
  rubberPrice: 0,
  organicPrice: 0,
};

export const CLASSES = {
  quotationClass: [
    {
      name: '',
      duration: '',
      purpose: '',
      detex: '',
      pricing: [{ ...PRICES }],
    },
    {
      name: '',
      duration: '',
      purpose: '',
      detex: '',
      pricing: [{ ...PRICES }],
    },
    {
      name: '',
      duration: '',
      purpose: '',
      detex: '',
      pricing: [{ ...PRICES }],
    },
    {
      name: '',
      duration: '',
      purpose: '',
      detex: '',
      pricing: [{ ...PRICES }],
    },
  ],
};

export const INFORMATION = {
  label: 'Company',
  data: null,
};

export const COMPANY = {
  city: '',
  cnpj: '',
  site: '',
  state: '',
  email: '',
  number: '',
  address: '',
  zipcode: '',
  district: '',
  whatsapp1: '',
  whatsapp2: '',
  instagram: '',
  informations: [{ ...INFORMATION }],
};

export const MESSAGES = {
  footer: '',
  slogan: '',
  contract: [{ ...INFORMATION }],
  sendMessage: '',
  sendMessageWhats: '',
};

export const ROW_RUBBER = {
  kilo: null,
  warranty: null,
  type: null,
};

export const ROW_ILLUMINATION = {
  min: null,
  max: null,
  group: null,
};

export const ROW_CLASS = {
  name: '',
  type_id: null,
  file_id: null,
};

export const GRASS_TYPE = [
  { name: 'Fibrilada', slug: 'fibrilada' },
  { name: 'Monofilamento', slug: 'monofilamento' },
];

export const SETTINGS = {
  tax: null,
  logo: null,
  warranty: null,
  timeAlert: null,
  ticketNotification: null,
  quotation: {
    rubber: [{ ...ROW_RUBBER }],
    illumination: [{ ...ROW_ILLUMINATION }],
    class: [{ ...ROW_CLASS }],
  },
};

export const OPTION = { id: null, slug: null, name: '' };

export const COLOR_OPTION = {
  id: null,
  name: '',
  color: '',
  time: 0,
  days: 0,
  hours: 0,
  minutes: 0,
};

export const PERMISSION = {
  module_id: null,
  name: null,
  description: null,
  slug: null,
  active: true,
};

export const MODEL_DRIVE_GOAL = {
  month: null, year: null, value: null,
};

export const MODEL_DRIVE = {
  id: null,
  slug: null,
  name: '',
  goals: [{ ...MODEL_DRIVE_GOAL }],
  goal_weekly: 0,
};

export const MONTHS = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
export const SLIDER = {
  id: '',
  type_id: null,
  image_id: null,
  order: 0,
  position: 'top',
  image: {
    id: null,
    name: null,
    url: null,
    uuid: null,
    type: null,
    size: null,
    file_name: null,
  },
};
